var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteWithWhiteCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8300)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8300",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.0226C21.8443 49.0249 18.7192 48.405 15.8033 47.1983C12.8874 45.9917 10.238 44.222 8.00677 41.9904C5.7755 39.7589 4.00609 37.1093 2.79978 34.1933C1.59346 31.2773 0.973913 28.1521 0.976571 24.9964C0.980683 19.4546 2.90013 14.0846 6.40981 9.79581C9.9195 5.50705 14.8037 2.5632 20.2351 1.46285C25.6666 0.362502 31.3114 1.1733 36.2135 3.75791C41.1157 6.34252 44.9738 10.5421 47.1345 15.6453C49.6087 21.5167 49.652 28.13 47.255 34.0333C44.8579 39.9366 40.2164 44.6476 34.3493 47.132C31.3922 48.3861 28.212 49.0292 25 49.0226ZM15.9756 17.7303V36.2886C15.9773 37.1088 16.3043 37.8948 16.8848 38.4743C17.4653 39.0537 18.252 39.3793 19.0722 39.3795H31.4387C32.2588 39.379 33.0453 39.0534 33.6258 38.474C34.2063 37.8946 34.5333 37.1087 34.5353 36.2886V17.7304L15.9756 17.7303ZM14.4326 13.091V16.1824H36.0778V13.0911H30.6652L29.1223 11.5428H21.3879L19.8441 13.0911L14.4326 13.091Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWithWhiteCircle);
export default __webpack_public_path__ + "static/media/delete_with_white_circle.b79984379436f1b3924fdfff0729c6b5.svg";
export { ForwardRef as ReactComponent };